// Router
import { Outlet, useOutletContext, useLocation } from "react-router-dom";

// Components
import { Stack } from "@mui/material";
import { NavBar } from "../NavBar";

const MBSPortal = () => {
  const location = useLocation();

  const { modePreference, onModePreferenceChange } = useOutletContext() || {};

  return (
    <Stack
      sx={{
        display: "block",
        minWidth: "300px",
        width: "100%",
        minHeight: "100vh",
        position: "relative",
        backgroundColor: "transparent",
      }}
    >
      <Stack
        spacing={2}
        sx={{
          py: 2,
          justifyContent: "flex-start",
          alignItems: "center",
          boxSizing: "border-box",
          position: "relative",
        }}
      >
        <NavBar
          modePreference={modePreference}
          onModePreferenceChange={onModePreferenceChange}
        />
        <Stack
          minHeight="80vh"
          key={location.pathname}
          alignItems="center"
          sx={{
            width: "100%",
            maxWidth: "64rem",
            px: { xs: 1.5, sm: 2 },
            boxSizing: "border-box",
            animation: "mbsRouteIn 350ms ease-out",
            "@media (prefers-reduced-motion: reduce)": {
              animation: "none",
            },
            "@keyframes mbsRouteIn": {
              from: { opacity: 0, transform: "translateY(8px)" },
              to: { opacity: 1, transform: "translateY(0)" },
            },
          }}
        >
          <Outlet />
        </Stack>
      </Stack>
    </Stack>
  );
};

export default MBSPortal;
